export const isNumber = (s: unknown): boolean => {
  return (
    // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    // @ts-expect-error [EN-7967] - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'number'.
    !isNaN(s) && // ...and ensure strings of whitespace fail
    // @ts-expect-error [EN-7967] - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string'.
    !isNaN(parseFloat(s))
  );
};
